import { ConfirmDialogHost } from '@/components/ConfirmAction';
import ReauthModal from '@/components/ReauthModal';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { bootstrap } from '@/lib/refresh';
import { useEffect } from 'react';
import { Providers } from './providers';
import { AppRoutes } from './routes';

export default function App() {
  useEffect(() => {
    void bootstrap();
  }, []);

  return (
    <Providers>
      {/* One tooltip delay for the whole product: radix needs a provider, and
          the default 700ms wait feels broken on a dense console. */}
      <TooltipProvider delayDuration={300}>
        <AppRoutes />
        <ReauthModal />
        <ConfirmDialogHost />
        <Toaster position="top-center" />
      </TooltipProvider>
    </Providers>
  );
}
